import dayjs from "dayjs"
import "dayjs/locale/pt-br"
dayjs.locale("pt-br")

export const semana = () => {
    return dayjs().format("dddd")
}

export default dayjs
